import { setMonitorInfo } from '@/utils'
import { CommonTag, YKY_PROVIDER_ID } from '@/utils/common'
import { wirteLog, IS_PRODUCTION } from '@/utils/weblog'
import { setGlobalInfo } from '@/utils/system-log'
export default {
  namespaced: true,
  state: {
    // 用户信息
    info: {
      buttonModule: []
    },
    userInfoInited: false
  },
  getters: {
    accessControl: (state, getters) => (key) => {
      const btnAvailable = getters.btnAccessible(key)
      const menuAvailable = getters.moduleAccessible(key)
      return btnAvailable || menuAvailable
    },
    btnAccessible: (state) => (key) => {
      let accessible = false
      if (key) {
        const { buttonModule } = state.info
        if (buttonModule) {
          accessible = buttonModule.some((v) => v === key)
        }
      }
      return accessible
    },
    moduleAccessible: (state) => (key) => {
      let accessible = false
      if (key) {
        const { moduleList } = state.info
        if (moduleList) {
          accessible = moduleList.some((v) => v === key)
        }
      }
      return accessible
    },
    /** 是否一块医药 */
    isYk: (state) => {
      return state.info.ysbProviderId === YKY_PROVIDER_ID
    },
    /** 是否数据隔离-商品 */
    productIsolatedFlag: (state) => {
      return state.info.productIsolatedFlag === CommonTag.yes
    },
    /** 是否数据隔离-供应商 */
    supplierIsolatedFlag: (state) => {
      return state.info.supplierIsolatedFlag === CommonTag.yes
    },
    getUserInfoInited: (state) => {
      return state.userInfoInited
    }
  },
  actions: {
    /**
     * @description 设置用户数据
     * @param {Object} context
     * @param {*} info info
     */
    set({ state, dispatch }, info) {
      return new Promise(async (resolve) => {
        // store 赋值
        state.info = info
        setMonitorInfo(info.phone, info.name)
        // 设置系统日志的全局信息
        setGlobalInfo(info)
        if (IS_PRODUCTION) {
          wirteLog({
            username: info.name,
            remark: '登录'
          })
        }
        // 持久化
        await dispatch(
          'd2admin/db/set',
          {
            dbName: 'sys',
            path: 'user.info',
            value: info,
            user: true
          },
          { root: true }
        )
        // end
        resolve()
      })
    },
    /**
     * @description 从数据库取用户数据
     * @param {Object} context
     */
    load({ state, dispatch }) {
      return new Promise(async (resolve) => {
        // store 赋值
        state.info = await dispatch(
          'd2admin/db/get',
          {
            dbName: 'sys',
            path: 'user.info',
            defaultValue: {},
            user: true
          },
          { root: true }
        )
        // 如果从数据库加载的用户信息有效，设置系统日志的全局信息
        if (state.info && state.info.name) {
          setGlobalInfo(state.info)
        }
        // end
        resolve()
      })
    },
    setUserInfoInited({ state }, inited) {
      state.userInfoInited = inited
    }
  }
}
